import { render, staticRenderFns } from "./modal_add_narasumber.vue?vue&type=template&id=a444c6b0"
import script from "./modal_add_narasumber.vue?vue&type=script&lang=js"
export * from "./modal_add_narasumber.vue?vue&type=script&lang=js"
import style0 from "./modal_add_narasumber.vue?vue&type=style&index=0&id=a444c6b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports